/**
 * Types for the Competition domain
 */

export type ProfileType =
  | "competitor"
  | "collaborator"
  | "influencer"
  | "inspiration"
  | "partner";

export type CompetitionPlatform =
  | "instagram"
  | "tiktok"
  | "website"
  | "facebook"
  | "youtube";

export interface CompetitionProfile {
  id: string;
  clientId: string;
  profileType: ProfileType;
  platform: CompetitionPlatform;
  handle: string | null;
  displayName: string;
  url: string | null;
  notes: string | null;
  tags: string[];
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateCompetitionProfileRequest {
  profileType?: ProfileType;
  platform: CompetitionPlatform;
  displayName: string;
  handle?: string;
  url?: string;
  notes?: string;
  tags?: string[];
}

export interface UpdateCompetitionProfileRequest {
  profileType?: ProfileType;
  displayName?: string;
  handle?: string;
  url?: string;
  notes?: string;
  tags?: string[];
}

export interface CompetitionProfilesResponse {
  profiles: CompetitionProfile[];
}

// Query keys factory
export const competitionKeys = {
  all: ["competition-profiles"] as const,
  lists: () => [...competitionKeys.all, "list"] as const,
  list: (clientId: string, platform?: CompetitionPlatform) =>
    [...competitionKeys.lists(), clientId, { platform }] as const,
  details: () => [...competitionKeys.all, "detail"] as const,
  detail: (id: string) => [...competitionKeys.details(), id] as const,
};

// Profile type display info
export const PROFILE_TYPE_CONFIG: Record<
  ProfileType,
  { label: string; color: string }
> = {
  competitor: { label: "Competitor", color: "red" },
  collaborator: { label: "Collaborator", color: "green" },
  influencer: { label: "Influencer", color: "purple" },
  inspiration: { label: "Inspiration", color: "blue" },
  partner: { label: "Partner", color: "amber" },
};

// Platform display info
export const PLATFORM_CONFIG: Record<
  CompetitionPlatform,
  { label: string; icon: string; color: string }
> = {
  instagram: { label: "Instagram", icon: "IG", color: "pink" },
  tiktok: { label: "TikTok", icon: "TT", color: "slate" },
  website: { label: "Website", icon: "W", color: "blue" },
  facebook: { label: "Facebook", icon: "f", color: "blue" },
  youtube: { label: "YouTube", icon: "YT", color: "red" },
};
